//maybe it corresponds to SliderChevron
import React from 'react'
import {Icon} from '@chakra-ui/react'

const LeftDarkBackgroundIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <circle
                cx="20"
                cy="20.0002"
                r="20"
                transform="rotate(180 20 20.0002)"
                fill="black"
                fillOpacity="0.75"
            />
            <path
                d="M18.5254 12.9497L19.5504 13.9997L15.4504 18.0997L14.1754 19.2497L28.5254 19.2497L28.5254 20.7497L14.1754 20.7497L15.4504 21.9247L19.5504 25.9997L18.5254 27.0497L11.4754 19.9997L18.5254 12.9497Z"
                fill="white"
            />
        </Icon>
    )
}

export default LeftDarkBackgroundIcon
